<script setup>
import { inject, defineProps , ref} from 'vue'
import {useDefineDynamicLink} from '@/composable/useDefineDynamicLink'
import { DEFAULT_IMAGE_PATH } from '@/config/filePath.config'
import ClImage from '@/components/base/ClImage.vue'
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
const numberConvertor = (number)=> {
  return Intl.NumberFormat('en').format(number)
}
const cards = ref([])

const storeFourUploadBaseUrl = inject('storeFourBaseUrl')

const getImageSrc = (image) => {
  return `${storeFourUploadBaseUrl}/filepond/product/${image}`
}
const heightCardManager = () => {
  cards.value.push(props.item)
}
heightCardManager()
</script>

<template>
  <v-card
    class="mx-auto rounded-xl text-decoration-none"
    max-width="380"
    min-width="95%"
    :to="useDefineDynamicLink(item)"
    min-height="95%"
    flat
    border
  >
    <ClImage
      path="PRODUCT"
      :default-image="DEFAULT_IMAGE_PATH.PRODUCTS"
      :alt="item.name"
      min-height="200px"
      :image="item.secondary_image ? item.secondary_image : item.img_filename"
      :aspect-ratio="1.77"
    />
    <v-card-text class="font-weight-medium py-0 my-4">
      {{ item.name }}
    </v-card-text>

    <v-card-text class="mb-4 py-0">
      <v-chip v-for="chip in item.grades" :key="chip.id" variant="text" border class="ml-1 mt-1 border-gray-light font-weight-bold rounded-lg"
              size="small">{{ chip.name }}
      </v-chip>
    </v-card-text>

    <v-card-text class="mb-4 py-0" v-if="item.price > 0">
       قیمت: {{ numberConvertor(item.price) }} ریال
    </v-card-text>
    <v-card-text class="mb-4 py-0" v-else>
       قیمت: رایگان
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">

</style>
